import React, { Fragment, useState } from "react";
import apiEndPoint from "../../../utils/apiEndPoint";
import { Navigate, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { loadFromLocalStorage, saveToLocalStorage } from "../../../utils/LocalStorageUtils";
import { apiCall, failedMessage, setDefaultHeader, successMessage } from "../../../utils/httpClient";
import { Button, Card, CloseButton, Container, Spinner } from "react-bootstrap";
import { CardBody, Modal, ModalHeader } from "reactstrap";
import { isEmpty } from "../../../utils/utils";
import LoginCover from '../logincover.png';
import "../auth.css";
import { FaApple, FaMobileAlt } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { BsMailbox, BsMailbox2 } from "react-icons/bs";
import GoolgeLoginModal from "../login/googleLogin";
import { useEffect } from "react";

function LoginMobile() {
  const [email, setEmail] = useState("");
  const [emailForget, setEmailForget] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isGoogleLogin, setIsGoogleLogin] = useState(false);
  const navigate = useNavigate();
  const authData = loadFromLocalStorage("AUTH_DATA");
  const [languageData, setLanguageData] = useState(null);
    const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
    useEffect(() => {
      setLanguageData(selectLang?.language)
    }, [selectLang])
  if (authData?.token) {
    return <Navigate to="/" />;
  }
  const validation = () => {
    let isError = true;
    let errorMessage = {};
    if (email === undefined || email === "") {
      isError = false;
      errorMessage["email"] = "Please Enter Email ID";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      isError = false;
      errorMessage["email"] = "Invalid email address";
    }
    if (password === undefined || password === "") {
      isError = false;
      errorMessage["password"] = "Please Enter Password";
    }
    setErrorMessage(errorMessage);
    return isError;
  };
  const validationForget = () => {
    let isError = true;
    let errorMessage = {};
    if (isEmpty(emailForget)) {
      isError = false;
      errorMessage["emailForget"] = "Please Enter Email ID";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailForget)) {
      isError = false;
      errorMessage["emailForget"] = "Invalid email address";
    }
    setErrorMessage(errorMessage);
    return isError;
  };
  const handleLogin = async () => {
    if (validation()) {
      setLoading(true);
      const params = {
        email: email,
        password: password,
        user_type: "user",
      };
      const { data } = await apiCall("post", apiEndPoint.LOGIN, params);
      if (data.status !== 200) {
        failedMessage(data.message);
      }
      if (data.status === 200) {
        successMessage(data.message);
        setDefaultHeader("token", data.data.token);
        saveToLocalStorage("AUTH_DATA", data.data);
        navigate("/");
      }
      setLoading(false);
    }
  };
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  const handleForgot = async () => {
    if (validationForget()) {
      setLoading(true);
      const params = {
        email: emailForget,
      };
      const { data } = await apiCall(
        "post",
        apiEndPoint.FORGOTPASSWORD,
        params
      );
      if (data.status !== 200) {
        failedMessage(data.message);
      } else {
        saveToLocalStorage("EMAIL_ADDRESS", emailForget);
        navigate("/verification?type=forgotpassword");
      }
      setLoading(false);
    }
  };
  return (
    <Fragment>
      <Container>
        {isGoogleLogin &&
          <GoolgeLoginModal />
        }
        <section className="log-in-section">
          <div className="login-bg">
            <div className="">
              <img
                src="/assets/images/fulllogo.png"
                alt="" width={200}
              />
            </div>
            <br />
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-lg-4 my-col-2">
                <div className="lt-text">
                  <h3>Welcome back!</h3>
                  <p>
                    Great to see you! Easily manage your website on the go—quick and simple.
                  </p>
                </div>
                <form>
                  <div className="form-group">
                    <div className="row">
                      <div className="col-lg-12 mt-adj">
                        <div className="input-field-box">
                          <label>{languageData?.enterUrmobi}  </label>
                          <input
                            htmlFor="email"
                            value={email}
                            type="number"
                            size="large"
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder={"e.g. 9000000009"}
                            className={`${errorMessage.email ? "input-errmsg" : ""
                              } form-control`}
                          />
                          {errorMessage.email && (
                            <span className="er-msg-show">
                              {errorMessage.email}
                            </span>
                          )}
                        </div>
                      </div>
                      {/* <div className="col-lg-12 mt-adj">
                        <div className="input-field-box">
                          <label>Enter your OTP</label>
                          <input
                            htmlFor="email"
                            value={email}
                            type="number"
                            size="large"
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder={"6 digit OTP"}
                            className={`${errorMessage.email ? "input-errmsg" : ""
                              } form-control`}
                          />
                          {errorMessage.email && (
                            <span className="er-msg-show">
                              {errorMessage.email}
                            </span>
                          )}
                        </div>
                      </div> */}
                    </div>
                    <br />
                    <div className="sav-btn mt-adj">
                      <button
                        type="button"
                        onClick={() => handleLogin()}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <Spinner animation="border" size="sm" role="status" />
                        ) : (
                          "Get OTP"
                        )}
                      </button>
                    </div>
                  </div>
                  <br />

                </form>
                <div style={{ position: 'relative' }}>
                  <p className="text-center" style={{ position: 'relative', top: '10px', zIndex: 1 }}>
                    <span style={{ background: '#fff', margin: '0', padding: '0 20px', }}>or</span>
                  </p>
                  <span style={{ margin: 0, borderTop: '1px solid #ddd', position: 'absolute', width: '100%', top: '20px', zIndex: 0 }} />
                </div> <br />
                <Button
                  variant="outline-dark"
                  className="w-100 my-2"
                  style={{ borderRadius: "30px", fontSize: 14 }}
                  onClick={() => navigate('/login')}
                >
                  <BsMailbox2 className="me-2" /> Login with Email
                </Button>

                <Button
                  variant="outline-dark"
                  className="w-100 my-2"
                  style={{ borderRadius: "30px", fontSize: 14 }}
                  onClick={() => setIsGoogleLogin(true)}
                >
                  <FcGoogle className="me-2" /> Login with Google
                </Button>

                <Button
                  variant="outline-dark"
                  className="w-100 my-2"
                  style={{ borderRadius: "30px", fontSize: 14 }}
                >
                  <FaApple className="me-2" /> Login with Apple
                </Button>
                <p className="pos-adj mt-4 text-center" style={{ color: '#444', fontWeight: 400 }}>
                  Don’t have an account yet?
                  <a style={{ fontWeight: 600 }}
                    onClick={() => {
                      navigate("/signup");
                    }}
                  >
                    Sign Up
                  </a>
                </p>
              </div>
              <div className="col-lg-8 my-col-1">
                <div className="text-center">
                  <img src={LoginCover} alt="login-vector" className="login-vector" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <Modal
          isOpen={isOpen}
          onRequestClose={() => setIsOpen(false)}
          style={customStyles}
          contentLabel="Example Modal"
          className="mt-4"
        >
          <Card>
            <ModalHeader toggle={() => setIsOpen(!isOpen)}>
              Forgot Password
            </ModalHeader>
            <CardBody>
              <div
                style={{ display: "flex" }}
                className="mt-2 align-items-center justify-content-md-center"
              >
                <center>
                  <small>We will send verification code on your email.</small>
                </center>
              </div>
              <form>
                <div className="form-group">
                  <div className="row">
                    <div className="col-lg-12 mt-2">
                      <div className="input-field-box">
                        <label>Email :</label>
                        <input
                          htmlFor="email"
                          // value={emailForget}
                          type="email"
                          size="large"
                          onChange={(e) => setEmailForget(e.target.value)}
                          placeholder={"example@yahoo.com"}
                          className={`${errorMessage.emailForget ? "input-errmsg" : ""
                            } form-control`}
                        />
                        {errorMessage.emailForget && (
                          <span className="er-msg-show">
                            {errorMessage.emailForget}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <center className="mt-2">
                    <Button
                      onClick={() => handleForgot()}
                      className="back-btn"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <Spinner animation="border" size="sm" role="status" />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </center>
                </div>
              </form>
            </CardBody>
          </Card>
        </Modal>
      </Container>
    </Fragment>
  );
}

export default LoginMobile;